module.exports = __webpack_public_path__ + "static/serverBio1-0f683d8b614c3d0565296ee15dd8e834.png";